
import { statsService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { GET_RTB_ERROR_STATS, GET_RTB_STATS, GET_CAMPAIGN_RTB_STATS, GET_CAMPAIGN_RTB_FAIL_REASONS, GET_CAMPAIGN_RTB_STATS_FOR_PUBLISHER, GET_CAMPAIGN_RTB_FAIL_REASONS_FOR_PUBLISHER } from './actionTypes';
import { SET_TOP_RTB_STATS, SET_TOP_RTB_FAIL_REASONS, SET_RTB_STATS, SET_RTB_FAIL_REASONS } from './mutationTypes';
import { SET_ACTION_STATUS_PENDING, SET_ACTION_STATUS_ERROR, SET_ACTION_STATUS_SUCCESS } from '@/store/helpers';


export const actions = {
  [GET_RTB_STATS]: async ({ rootState, commit }, params) => {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_RTB_STATS });
    commit(SET_TOP_RTB_STATS, null);
    try {
      const stats = await statsService.getTopRtbStats(rootState.currentAccountId, params.past, params.days);
      commit(SET_TOP_RTB_STATS, stats);
      commit(SET_ACTION_STATUS_SUCCESS, {actionName: GET_RTB_STATS });
      return stats;
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, {actionName: GET_RTB_STATS, error: e });
    }
  },
  [GET_CAMPAIGN_RTB_STATS]: async ({ rootState, commit }, params) => {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_RTB_STATS });
    commit(SET_RTB_STATS, []);
    try {
      const stats = await statsService.getCampaignRtbStats(rootState.currentAccountId, {
        past: params.past,
        days: params.days,
        searchBy: 'campaignAffiliate',
        campaignId: params.campaignId
      });
      commit(SET_RTB_STATS, stats);
      commit(SET_ACTION_STATUS_SUCCESS, {actionName: GET_RTB_STATS });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, {actionName: GET_RTB_STATS, error: e });
    }
  },
  [GET_CAMPAIGN_RTB_STATS_FOR_PUBLISHER]: async ({ rootState, commit }, params) => {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_RTB_STATS });
    commit(SET_RTB_STATS, []);
    try {
      const stats = await statsService.getCampaignRtbStatsForPublisher(rootState.currentAccountId, {
        past: params.past,
        days: params.days,
        searchBy: 'campaignAffiliate',
        campaignId: params.campaignId
      });
      commit(SET_RTB_STATS, stats);
      commit(SET_ACTION_STATUS_SUCCESS, {actionName: GET_RTB_STATS });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, {actionName: GET_RTB_STATS, error: e });
    }
  },
  [GET_RTB_ERROR_STATS]: async ({ rootState, commit }, params) => {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_RTB_ERROR_STATS });
    commit(SET_TOP_RTB_FAIL_REASONS, null);
    try {
      const failReasons = await statsService.getTopRtbFailReasonStats(rootState.currentAccountId, params.past, params.days);
      commit(SET_TOP_RTB_FAIL_REASONS, failReasons);
      commit(SET_ACTION_STATUS_SUCCESS, {actionName: GET_RTB_ERROR_STATS });
      return failReasons;
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, {actionName: GET_RTB_ERROR_STATS, error: e });
    }
  },
  [GET_CAMPAIGN_RTB_FAIL_REASONS]: async ({ rootState, commit }, params) => {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_RTB_ERROR_STATS });
    commit(SET_RTB_FAIL_REASONS, []);
    try {
      const stats = await statsService.getCampaignRtbFailReasons(rootState.currentAccountId, {
        past: params.past,
        days: params.days,
        searchBy: 'campaignAffiliate',
        campaignId: params.campaignId
      });
      commit(SET_RTB_FAIL_REASONS, stats);
      commit(SET_ACTION_STATUS_SUCCESS, {actionName: GET_RTB_ERROR_STATS });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, {actionName: GET_RTB_ERROR_STATS, error: e });
    }
  },
  [GET_CAMPAIGN_RTB_FAIL_REASONS_FOR_PUBLISHER]: async ({ rootState, commit }, params) => {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_RTB_ERROR_STATS });
    commit(SET_RTB_FAIL_REASONS, []);
    try {
      const stats = await statsService.getCampaignRtbFailReasonsForPublisher(rootState.currentAccountId, {
        past: params.past,
        days: params.days,
        searchBy: 'campaignAffiliate',
        campaignId: params.campaignId
      });
      commit(SET_RTB_FAIL_REASONS, stats);
      commit(SET_ACTION_STATUS_SUCCESS, {actionName: GET_RTB_ERROR_STATS });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, {actionName: GET_RTB_ERROR_STATS, error: e });
    }
  },
    
};
